module.exports = __webpack_public_path__ + "static/media/background-dots.3cf32ff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/background-dots.png
// module id = 243
// module chunks = 0